import { render, staticRenderFns } from "./PICHeader.vue?vue&type=template&id=f525ade6&scoped=true"
import script from "./PICHeader.vue?vue&type=script&lang=js"
export * from "./PICHeader.vue?vue&type=script&lang=js"
import style0 from "./PICHeader.vue?vue&type=style&index=0&id=f525ade6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f525ade6",
  null
  
)

export default component.exports